import * as types from '../action-types';
import { ActionSidebarRemoveReducerType } from '../decisionState.types';
import { ActionSidebarRemoveActions } from '../actions';

const initialState: ActionSidebarRemoveReducerType = {
  isOpen: false,
  top: -9999,
  left: 0,
};

export function actionSidebarRemoveReducer(
  state: ActionSidebarRemoveReducerType = initialState,
  action: ActionSidebarRemoveActions,
) {
  switch (action.type) {
    case types.openActionSidebarRemovePopover: {
      const { data } = action.payload;
      return { ...state, isOpen: true, ...data };
    }
    case types.closeActionSidebarRemovePopover: {
      return {
        ...state,
        isOpen: false,
        top: -9999,
      };
    }
    default: {
      return state;
    }
  }
}
